import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: 'login',
            component: () => import('../views/Index.vue'),
            children: [
                {
                    path: 'auth',
                    redirect: 'login',
                    component: () => import('../views/Gate.vue'),
                    meta: {
                        auth: false
                    },
                    children: [
                        {
                            name: 'login',
                            path: '/login',
                            meta: {
                                auth: false
                            },
                            component: () => import('../views/gate/Login.vue')
                        },
                        // {
                        //     name: 'register',
                        //     path: '/register',
                        //     meta: {
                        //         auth: false
                        //     },
                        //     component:  () =>  import('../views/gate/Register.vue')
                        // },
                        // {
                        //     name: 'fcr-register',
                        //     path: '/free-credit-report',
                        //     meta: {
                        //         auth: false
                        //     },
                        //     component: () => import('../views/gate/FCRRegister.vue')
                        // },
                        {
                            name: 'verify',
                            path: '/verify',
                            props: true,
                            meta: {
                                auth: true,
                                browserToken: false
                            },
                            component:  () => import('../views/gate/Verify.vue')
                        }
                        , {
                            name: 'forget',
                            path: '/forget',
                            meta: {
                                auth: false,
                                browserToken: false
                            },
                            component:  () => import('../views/gate/Forget.vue')
                        }, {
                            name: 'logout',
                            path: '/logout',
                            component:  () => import('../views/gate/Logout.vue')
                        }, {
                            name: 'suspicious-activity',
                            path: '/suspicious-activity',
                            meta: {
                                auth: false,
                                browserToken: false
                            },
                            component: () => import('../views/gate/SuspiciousActivity')
                        }
                    ]
                },
                {
                    path: 'app',
                    component: () => import('../views/App.vue'),
                    meta: {
                        auth: true,
                        browserToken: true
                    },
                    children: [
                        {
                            path: 'dashboard',
                            meta: {
                                auth: true,
                                browserToken: true
                            },
                            component: () => import('../views/app/Index.vue'),
                            children: [
                                {
                                    name: 'dashboard',
                                    path: '',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/Dashboard.vue'),
                                },
                                {
                                    name: 'profile',
                                    path: 'profile',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/Profile.vue'),
                                },
                                {
                                    name: 'contact-us',
                                    path: 'contact-us',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/ContactUs.vue'),
                                },
                                {
                                    name: 'overdraft',
                                    path: 'overdraft',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/Overdraft.vue'),
                                },
                                {
                                    path: 'wallet',
                                    component: () => import('../views/app/wallet/Index'),
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    children: [
                                        {
                                            name: 'wallet',
                                            path: '',
                                            meta: {
                                                auth: true,
                                                browserToken: true
                                            },
                                            component: () => import('../views/app/wallet/Home')
                                        },
                                        {
                                            name: 'fund-wallet',
                                            path: 'fund-wallet',
                                            props: true,
                                            meta: {
                                                auth: true,
                                                browserToken: true
                                            },
                                            component: () => import('../views/app/wallet/Fund')
                                        },
                                        {
                                            name: 'wallet-transactions',
                                            path: 'wallet-transactions',
                                            meta: {
                                                auth: true,
                                                browserToken: true
                                            },
                                            component: () => import('../views/app/wallet/Transaction')
                                        },
                                        {
                                            name: 'wallet-detail',
                                            path: 'wallet-detail',
                                            props: true,
                                            meta: {
                                                auth: true,
                                                browserToken: true
                                            },
                                            component: () => import('../views/app/wallet/Detail')
                                        },
                                        {
                                            name: 'payment-detail',
                                            path: 'payment-detail',
                                            props: true,
                                            meta: {
                                                auth: true,
                                                browserToken: true
                                            },
                                            component: () => import('../views/app/wallet/Payment')
                                        }
                                    ]
                                },
                                {
                                    name: 'under-construction',
                                    path: 'under-construction',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/UnderConstructor.vue'),
                                },
                            ]
                        },
                        {
                            path: 'credit-report',
                            component: () => import('../views/app/creditReport/Index'),
                            meta: {
                                auth: true,
                                browserToken: true
                            },
                            children: [
                                {
                                    name: 'credit-report',
                                    path: '',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/creditReport/Home')
                                }
                            ]
                        },
                        {
                            path: 'complaint',
                            component: () => import('../views/app/complaint/Index'),
                            meta: {
                                auth: true,
                                browserToken: true
                            },
                            children: [
                                {
                                    name: 'complaint',
                                    path: '',
                                    meta: {
                                        auth: true,
                                        browserToken: true
                                    },
                                    component: () => import('../views/app/complaint/Home')
                                }
                            ]
                        },
                        // {
                        //     path: 'bills-payment',
                        //     component: () => import('../views/app/billPayment/Index'),
                        //     meta: {
                        //         auth: true,
                        //         browserToken: true
                        //     },
                        //     children: [
                        //         {
                        //             name: 'bills-payment',
                        //             path: '',
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/billPayment/Home')
                        //         },
                        //         {
                        //             name: 'bills-payment-cateogry',
                        //             path: 'category/:id/:title',
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/billPayment/Category')
                        //         },
                        //         {
                        //             name: 'bills-payment-cable-tv',
                        //             path: 'cable-tv',
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component:  () => import('../views/app/billPayment/CableTv')
                        //         }
                        //     ]
                        // },
                        // {
                        //     path: 'buy-airtime',
                        //     component: () => import('../views/app/airtime/Index'),
                        //     meta: {
                        //         auth: true,
                        //         browserToken: true
                        //     },
                        //     children: [
                        //         {
                        //             name: 'buy-airtime',
                        //             path: '',
                        //             props: true,
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/airtime/Home')
                        //         },
                        //         {
                        //             name: 'airtime-detail',
                        //             path: 'airtime-detail',
                        //             props: true,
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/airtime/Detail')
                        //         }
                        //     ]
                        // },
                        // {
                        //     path: 'send-money',
                        //     component: () => import('../views/app/sendMoney/Index'),
                        //     meta: {
                        //         auth: true,
                        //         browserToken: true
                        //     },
                        //     children: [
                        //         {
                        //             name: 'send-money',
                        //             path: '',
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/sendMoney/Home')
                        //         },
                        //         {
                        //             name: 'send-money-to-bank',
                        //             path: 'to-bank',
                        //             props: true,
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/sendMoney/toBank')
                        //         },
                        //         {
                        //             name: 'send-money-to-wallet',
                        //             path: 'to-wallet',
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/sendMoney/toWallet')
                        //         },
                        //         {
                        //             name: 'transfer-detail',
                        //             path: 'transfer-detail',
                        //             props: true,
                        //             meta: {
                        //                 auth: true,
                        //                 browserToken: true
                        //             },
                        //             component: () => import('../views/app/sendMoney/Detail')
                        //         }
                        //     ]
                        // },
                    ]
                }]
        }
        , {
            path: '*',
            redirect:
                'login'
        }
    ]
});

function guardRoute(route, redirect, next, auth, browserToken) {
    let lsAuth = localStorage.getItem('auth_token');
    let lsBrowserToken = localStorage.getItem('browser_token');
    const queryParams = route.name ? {"redirect-from": route.name} : {};
    if (auth === null && browserToken === null) {
        next()
        return;
    }
    if (auth && lsAuth === null) {
        router.push({
            name: "login",
            query: {...route.query, ...queryParams}
        });
        return;
    }
    if (browserToken && lsBrowserToken === null) {
        router.push({
            name: "verify",
            query: {...route.query, ...queryParams}
        });
        return;
    }
    next()
    return;
}

router.beforeEach( ( route, redirect, next ) => {
    Vue.swal.close()
    $("body").removeClass("swal2-shown");

    let auth = typeof route.meta.auth !== "undefined" ? route.meta.auth : null;
    let browserToken = typeof route.meta.browserToken !== "undefined" ? route.meta.browserToken : null;
    guardRoute(route, redirect, next, auth, browserToken)
    // if (typeof route.meta.auth !== "undefined" && route.meta.auth != null) {
    //     guardRoute(route, redirect, next, route.meta.auth, route.meta.browserToken)
    // } else {
    //     next()
    // }
})


export default router
